import React from 'react';
import { message } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import HistoryParcelLink from './HistoryParcelLink';
import { HistoryParcelSystem } from './historyLink';
import './parcelQueryRange.css';

interface PartialNotFoundBarProps {
    system: HistoryParcelSystem;
    days: number;
    /** 未查到的运单号；为空时不显示 */
    missingTrackingNumbers: string[];
    /** 本次查询使用的筛选条件，跳转时除运单号外照常带入 */
    filters: Record<string, any> | null | undefined;
}

/** 结果列表上方的「N 个运单未查到」提示条，不可关闭，随下次查询重新计算 */
const PartialNotFoundBar: React.FC<PartialNotFoundBarProps> = ({ system, days, missingTrackingNumbers, filters }) => {
    const { t } = useTranslation();
    if (missingTrackingNumbers.length === 0) {
        return null;
    }

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(missingTrackingNumbers.join('\n'));
            message.success(t('parcelQueryRange.copied'));
        } catch (e) {
            message.error(t('parcelQueryRange.copyFailed'));
        }
    };

    return (
        <div className="pqr-partial-bar" role="status">
            <span>
                <InfoCircleOutlined className="mr-2" />
                {t('parcelQueryRange.partialNotFound', { count: missingTrackingNumbers.length, days })}{' '}
                <HistoryParcelLink
                    system={system}
                    filters={filters}
                    override={{ trackingNumbers: missingTrackingNumbers.join('\n') }}
                    source="partialNotFound"
                />
            </span>
            <button type="button" className="pqr-link whitespace-nowrap bg-transparent border-0 p-0" onClick={handleCopy}>
                {t('parcelQueryRange.copyNotFound')}
            </button>
        </div>
    );
};

export default PartialNotFoundBar;
